export default __webpack_public_path__ + "static/media/icn-handle.a48e560a.svg";